/**
 * Index redirect for `/clawinstall/admin/customers/:customerId`.
 *
 * The zinc customer-detail layout was retired; the tab screens now live under
 * `admin_/customers/$customerId/` with their own design frames. A bare customer
 * URL therefore has no landing content of its own, so this eager route redirects
 * to the default `overview` tab in `beforeLoad` — the same server-side idiom the
 * legacy `installs/index.tsx` redirect uses. A redirect-only route needs no lazy
 * half.
 *
 * @since 1.0.0
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/clawinstall/admin_/customers/$customerId/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/clawinstall/admin/customers/$customerId/overview",
      params,
    });
  },
});
